import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import { Column, Pie } from "@ant-design/plots";

const CommercialChart = (props) => {
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [cropwiseSalesFilter, setCropwiseSalesFilter] = useState(
    "RegionCropwiseSales"
  );
  const [cropwiseSalesReturnFilter, setcropwiseSalesReturnFilter] = useState(
    "RegionCropwiseSalesReturn"
  );
  const [productwiseSalesFilter, SetProductwiseSalesFilter] = useState(
    "RegionProductwiseSales"
  );

  const [expenseData, setExpenseData] = useState([]);
  const [cropwiseSalesData, setCropwiseSalesData] = useState([]);
  const [cropwiseSalesReturnData, setCropwiseSalesReturnData] = useState([]);
  const [productwiseSalesData, setProductwiseSalesData] = useState([]);
  const [customerwiseSalesData, setCustomerwiseSalesData] = useState([]);

  const [
    executivewiseCropSalesReturnData,
    setExecutivewiseCropSalesReturnData,
  ] = useState([]);
  const [executivewiseCropSalesData, setExecutivewiseCropSalesData] = useState(
    []
  );
  const [expenseRegionData, setExpenseRegionData] = useState([]);
  const [regionProductwiseSalesData, setRegionProductwiseSalesData] = useState(
    []
  );
  const [regionCustomerwiseSalesData, setRegionCustomerwiseSalesData] =
    useState([]);

  const [goodsIssueData, setGoodsIssueData] = useState([]);

  const [executivewiseGoodsIssueData, setExecutivewiseGoodsIssueData] =
    useState([]);

  //  New State
  const [cropwiseAreacoveredAll, setCropwiseAreacoveredAll] = useState([]);
  const [cropwiseAreacovered, setCropwiseAreacovered] = useState([]);
  const [regionCropArea, setRegionCropArea] = useState("--All--");

  const [cropwiseHarvestAll, setCropwiseHarvestAll] = useState([]);
  const [cropwiseHarvest, setCropwiseHarvest] = useState([]);
  const [regionCropsHarvest, setRegionCropsHarvest] = useState("--All--");

  const [cropwiseYieldEstiamtionAll, setCropwiseYieldEstiamtionAll] = useState(
    []
  );
  const [cropwiseYieldEstiamtion, setCropwiseYieldEstiamtion] = useState([]);
  const [regionCropsYieldEstiamtion, setRegionCropsYieldEstiamtion] =
    useState("--All--");

  const [
    cropwiseYieldEstiamtionVSHarvestAll,
    setCropwiseYieldEstiamtionVSHarvestAll,
  ] = useState([]);
  const [
    cropwiseYieldEstiamtionVSHarvest,
    setCropwiseYieldEstiamtionVSHarvest,
  ] = useState([]);
  const [
    regionCropsYieldEstiamtionVSHarvest,
    setRegionCropsYieldEstiamtionVSHarvest,
  ] = useState("--All--");

  const { sendRequest: getcropwiseAreacoveredAll } = useHttp();

  const fillallChartData = () => {
    //console.log("fillallChartData",fillallChartData)
    var urlfilter = "";

    var url = `/api/cropwiseAreacovered/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    getcropwiseAreacoveredAll(
      {
        url: url,
      },
      (data) => {
        //console.log("getcropwiseAreacoveredAll",data)

        setCropwiseAreacoveredAll(data.cropwiseAreacovered);

        setCropwiseHarvestAll(data.cropwiseHarvest);
        setCropwiseYieldEstiamtionAll(data.cropsYieldEstiamtion);
        setCropwiseYieldEstiamtionVSHarvestAll(data.cropsYieldEstiamtion);

        loadcropwiseAreacovered(data.cropwiseAreacovered, 0);
        loadcropwiseHarvestcovered(data.cropwiseHarvest, 0);
        loadcropwisecropsYieldEstiamtion(data.cropsYieldEstiamtion, 0);
        loadcropwisecropsYieldEstiamtionVSHarvest(data.cropsYieldEstiamtion, 0);
      }
    );
  };
  useEffect(() => {
    fillallChartData();
  }, [getcropwiseAreacoveredAll]);

  const loadcropwiseAreacovered = (data, id) => {
    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropArea == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalCropArea = 0;
        selectedcroplist.forEach((item) => {
          totalCropArea += parseFloat(item.CropArea || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          CropArea: totalCropArea,
        });

        i++;
      } while (croplist.length > i);

      // //console.log("cropwiseAreacovered 456",newcropData)    ;

      setCropwiseAreacovered(newcropData);
    }
  };

  const loadcropwiseHarvestcovered = (data, id) => {
    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropsHarvest == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalHarvestQuantity = 0;
        selectedcroplist.forEach((item) => {
          totalHarvestQuantity += parseFloat(item.HarvestQuantity || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          Quantity: totalHarvestQuantity,
        });

        i++;
      } while (croplist.length > i);

      setCropwiseHarvest(newcropData);
    }
  };

  const loadcropwisecropsYieldEstiamtion = (data, id) => {
   
    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropsYieldEstiamtion == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalHarvestQuantity = 0;
        var totalEstiamtionQuantity = 0;
        selectedcroplist.forEach((item) => {
          totalHarvestQuantity += parseFloat(item.HarvestQuantity || 0);
          totalEstiamtionQuantity += parseFloat(item.EstiamtionQuantity || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          Quantity: totalEstiamtionQuantity,
        });

        i++;
      } while (croplist.length > i);
      //console.log("loadcropwisecropsYieldEstiamtion",newcropData)
      setCropwiseYieldEstiamtion(newcropData);
    }
  };

  const loadcropwisecropsYieldEstiamtionVSHarvest = (data, id) => {
    //console.log("loadcropwisecropsYieldEstiamtionVSHarvest",id)
    if (data && data.length > 0) {
      var tempData = data;

      //console.log("data 456",tempData)

      if (id != 0) {
        if (regionCropsYieldEstiamtionVSHarvest == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      //console.log("data 456",tempData)
      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalHarvestQuantity = 0;
        var totalEstiamtionQuantity = 0;
        selectedcroplist.forEach((item) => {
          totalHarvestQuantity += parseFloat(item.HarvestQuantity || 0);
          totalEstiamtionQuantity += parseFloat(item.EstiamtionQuantity || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          label: croplist[i],
          type: "Harvest",
          value: totalHarvestQuantity,
        });

        newcropData = newcropData.concat({
          label: croplist[i],
          type: "Estimate",
          value: totalEstiamtionQuantity,
        });

        i++;
      } while (croplist.length > i);

      //console.log("RegionCropsYieldEstiamtionVSHarvest 456",newcropData)    ;

      setCropwiseYieldEstiamtionVSHarvest(newcropData);
    }
  };

  const { sendRequest: getGoodsIssueData } = useHttp();

  const { sendRequest: getProductData } = useHttp();

  const fillGoodsIssueData = (employeeId, regionId) => {
    var urlfilter = "";
    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/farmerGoodsIssuereport/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    var productMasterData = [];

    getProductData(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          productMasterData = res;

          getGoodsIssueData(
            {
              url: url,
            },
            (data) => {
              //  //console.log("GI reportdata", data);

              var goodsIssueData = data;
              var newList = [];
              var i = 0;
              do {
                var farmeritem = goodsIssueData[i];
                //  //console.log("farmeritem", farmeritem);

                if (farmeritem.goodsIssue.length > 0) {
                  //  //console.log("farmeritem.goodsIssue", farmeritem.goodsIssue);
                  var strgoodsIssue = JSON.stringify(farmeritem.goodsIssue);

                  var goodsIssue = JSON.parse(strgoodsIssue);

                  var j = 0;

                  do {
                    var goodsIssueitem = goodsIssue[j];
                    var strproductDetails = JSON.stringify(
                      goodsIssueitem.productDetails
                    );
                    var productDetails = JSON.parse(
                      JSON.parse(strproductDetails)
                    );
                    //  //console.log("productDetails", productDetails);

                    var k = 0;

                    do {
                      var productItem = productDetails[k];

                      var newList = newList.concat({
                        fieldExecutiveName: farmeritem.executiveName,
                        regionName: farmeritem.regionName,
                        fieldExecutiveId: farmeritem.fieldExecutiveId,
                        regionId: farmeritem.regionId,
                        farmerNo: farmeritem.farmerNo,
                        farmerName: farmeritem.farmerName,
                        goodsIssueDate: goodsIssueitem.goodsIssueDate,
                        totalAmount: goodsIssueitem.totalAmount,
                        discountAmount: goodsIssueitem.discountAmount,
                        discount: goodsIssueitem.discount,
                        productName: productItem.productName,
                        productId: productItem.productId,
                        Quantity: productItem.Quantity,
                        unitAbbreviation: productItem.unitAbbreviation,
                        amount: productItem.useAmt,
                      });

                      k++;
                    } while (productDetails.length > k);

                    j++;
                  } while (goodsIssue.length > j);
                }

                i++;
              } while (goodsIssueData.length > i);

              //  //console.log("Product newList", newList);

              var fieldExecutiveNamelist = [
                ...new Set(newList.map((q) => q.fieldExecutiveName)),
              ];

              var productIdlist = [...new Set(newList.map((q) => q.productId))];

              i = 0;
              var newProductList = [];
              do {
                var j = 0;
                do {
                  var selectedcroplist = newList.filter(
                    (item) =>
                      item.productId == productIdlist[j] &&
                      item.fieldExecutiveName == fieldExecutiveNamelist[i]
                  );

                  var totalAmount = 0;

                  selectedcroplist.forEach((item) => {
                    totalAmount += parseFloat(item.amount || 0);
                  });

                  var productTypeName = "";
                  var productSubTypeName = "";

                  if (parseFloat(totalAmount) > 0) {
                    var dataitem = selectedcroplist[0];
                    var itemlist = productMasterData.filter(
                      (item) => item.productId == dataitem.productId
                    );

                    if (itemlist.length > 0) {
                      productTypeName = itemlist[0].productTypeName;
                      productSubTypeName = itemlist[0].productSubTypeName;
                    }

                    var newProductList = newProductList.concat({
                      fieldExecutiveName: dataitem.fieldExecutiveName,
                      regionName: dataitem.regionName,

                      fieldExecutiveId: dataitem.fieldExecutiveId,
                      regionId: dataitem.regionId,

                      productId: dataitem.productId,
                      totalAmount: totalAmount,
                      productTypeName: productTypeName,
                      productSubTypeName: productSubTypeName,
                    });
                  }
                  j++;
                } while (productIdlist.length > j);

                i++;
              } while (fieldExecutiveNamelist.length > i);

              //  //console.log("newProductList",newProductList);
              setGoodsIssueData(newProductList);
              loadGoodsIssueFilterData(newProductList, 0);
            }
          );
        }
      }
    );
  };
  useEffect(() => {
    fillGoodsIssueData(0);
  }, [getGoodsIssueData]);

  const loadGoodsIssueFilterData = (data, id) => {
    //  //console.log("loadGoodsIssueFilterData")
    if (data && data.length > 0) {
      var tempData = data;

      //  //console.log("id",id)
      //  //console.log("data",data)

      // if (id != 0) {
      //   // ExecutiveCropwiseArea
      //   // RegionCropwiseArea
      //   if (cropwiseProcurementFilter == "RegionCropwiseArea") {
      //     tempData = data.filter((item) => item.regionId == id);
      //   } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      // }

      ////  //console.log("loadCropPaymentFilterData tempData",tempData)

      var productTypeNamelist = [
        ...new Set(tempData.map((q) => q.productTypeName)),
      ];
      //  //console.log('productTypeNamelist',productTypeNamelist);
      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.productTypeName == productTypeNamelist[i]
        );

        var totalAmount = 0;
        selectedcroplist.forEach((item) => {
          totalAmount += parseFloat(item.totalAmount || 0);
        });

        newcropData = newcropData.concat({
          productTypeName: productTypeNamelist[i],
          Amount: totalAmount,
        });

        i++;
      } while (productTypeNamelist.length > i);

      //console.log("setExecutivewiseGoodsIssueData", newcropData);
      setExecutivewiseGoodsIssueData(newcropData);
    }
  };

  const data = [
    {
      label: "Apple.",
      type: "Yield",
      value: 2800,
    },
    {
      label: "Apple.",
      type: "Harvest",
      value: 2260,
    },
    {
      label: "Banana.",
      type: "Yield",
      value: 1800,
    },
    {
      label: "Banana.",
      type: "Harvest",
      value: 1300,
    },
    {
      label: "Tomato.",
      type: "Yield",
      value: 950,
    },
    {
      label: "Tomato.",
      type: "Harvest",
      value: 900,
    },
    {
      label: "Bell Paper.",
      type: "Yield",
      value: 500,
    },
    {
      label: "Bell Paper.",
      type: "Harvest",
      value: 390,
    },
    {
      label: "Pineapple.",
      type: "Yield",
      value: 170,
    },
    {
      label: "Pineapple.",
      type: "Harvest",
      value: 100,
    },
  ];

  const configbar2 = {
    data: cropwiseYieldEstiamtionVSHarvest,
    isGroup: true,
    xField: "label",
    yField: "value",
    seriesField: "type",

    label: {
      position: "top",

      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
    },
    scrollbar: {
      type: "horizontal",
    },
  };

  const config = {
    data: cropwiseAreacovered,
    xField: "CropName",
    yField: "CropArea",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Area",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Area",
      },
      quantityBal: {
        alias: "Total Area",
      },
    },
  };

  const harvestconfig = {
    data: cropwiseHarvest,
    xField: "CropName",
    yField: "Quantity",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Quantity",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  const goodsIssueDetailConfig = {
    data: executivewiseGoodsIssueData,
    xField: "productTypeName",
    yField: "Amount",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Amount",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  const YieldEstiamtionconfig = {
    data: cropwiseYieldEstiamtion,
    xField: "CropName",
    yField: "Quantity",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Quantity",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  // const config = {
  //   data: data,
  //   xField: "productTitle",
  //   yField: "quantityBal",
  //   label: {
  //     position: "middle",

  //     style: {
  //       fill: "#FFFFFF",
  //       opacity: 0.6,
  //     },
  //   },
  //   xAxis: {
  //     label: {
  //       // autoHide: true,
  //       autoRotate: false,
  //       rotate: 220,
  //     },
  //     title: {
  //       text: "Products",
  //     },
  //   },
  //   yAxis: {
  //     title: {
  //       text: "stock",
  //     },
  //   },
  //   scrollbar: {
  //     type: "horizontal",
  //   },
  //   meta: {
  //     productTitle: {
  //       alias: "products",
  //     },
  //     quantityBal: {
  //       alias: "total stock",
  //     },
  //   },
  // };

  const { sendRequest: getWarehouseData } = useHttp();

  const handleChange = (event) => {
    //console.log(event.target.value);
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [selectedToDate, setSelectedToDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleToDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const fromDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem("orgId")}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // //console.log("emp",data.output )
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data);
      }
    );
  }, [getRegion]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <h2>Commercial Farming Dashboard</h2>
            </div>
            <div className="row"></div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Cropwise Area Covered</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={regionCropArea}
                          onChange={(e) => {
                            setRegionCropArea(e.target.value);
                            loadcropwiseAreacovered(cropwiseAreacoveredAll, 0);
                          }}
                        >
                          <option>--All--</option>
                          <option value="Regionwise">Regionwise</option>
                          <option value="Executivewise">Executivewise</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        {regionCropArea == "Regionwise" ? (
                          <select
                            id="regionId"
                            className="form-control"
                            ref={(el) => (frmRef.current["regionId"] = el)}
                            value={regionId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Region--") {
                                id = e.target.value;
                              }
                              loadcropwiseAreacovered(
                                cropwiseAreacoveredAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Region--</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option
                                  key={x.regionId}
                                  user-id={x.regionId}
                                  value={x.regionId}
                                >
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_id"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Executive--") {
                                id = e.target.value;
                              }
                              loadcropwiseAreacovered(
                                cropwiseAreacoveredAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Executive--</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.userId}
                                  user-id={x.userId}
                                  value={x.userId}
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>
                    </div>
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      &nbsp;{" "}
                      {/* <Charts chart={executivewiseCropSalesData} /> */}
                      <Column {...config} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Cropwise Harvest</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["salesreturnid"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            setRegionCropsHarvest(e.target.value);
                            loadcropwiseHarvestcovered(cropwiseHarvestAll, 0);
                          }}
                        >
                          <option>--All--</option>
                          <option value="Regionwise">Regionwise</option>
                          <option value="Executivewise">Executivewise</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        {regionCropsHarvest == "Regionwise" ? (
                          <select
                            id="regionId"
                            className="form-control"
                            ref={(el) => (frmRef.current["regionId"] = el)}
                            value={regionId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Region--") {
                                id = e.target.value;
                              }
                              loadcropwiseHarvestcovered(
                                cropwiseHarvestAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Region--</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option
                                  key={x.regionId}
                                  user-id={x.regionId}
                                  value={x.regionId}
                                >
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_id"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Executive--") {
                                id = e.target.value;
                              }
                              loadcropwiseHarvestcovered(
                                cropwiseHarvestAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Executive--</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.userId}
                                  user-id={x.userId}
                                  value={x.userId}
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>
                    </div>
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      &nbsp;{" "}
                      {/* <Charts chart={executivewiseCropSalesData} /> */}
                      <Column {...harvestconfig} />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <div className="card card-primary shadow">
                <div className="card-header">
                  <h3 className="card-title"> Estimated Yield</h3>

                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={regionCropArea}
                        onChange={(e) => {
                          setRegionCropsYieldEstiamtion(e.target.value);
                          loadcropwisecropsYieldEstiamtion(
                            cropwiseYieldEstiamtionAll,
                            0
                          );
                        }}
                      >
                        <option>--All--</option>
                        <option value="Regionwise">Regionwise</option>
                        <option value="Executivewise">Executivewise</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      {regionCropsYieldEstiamtion == "Regionwise" ? (
                        <select
                          id="regionId"
                          className="form-control"
                          ref={(el) => (frmRef.current["regionId"] = el)}
                          value={regionId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Region--") {
                              id = e.target.value;
                            }

                            loadcropwisecropsYieldEstiamtion(
                              cropwiseYieldEstiamtionAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Region--</option>
                          {regionData &&
                            regionData.map((x) => (
                              <option
                                key={x.regionId}
                                user-id={x.regionId}
                                value={x.regionId}
                              >
                                {x.regionName}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Executive--") {
                              id = e.target.value;
                            }
                            loadcropwisecropsYieldEstiamtion(
                              cropwiseYieldEstiamtionAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Executive--</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option
                                key={x.userId}
                                user-id={x.userId}
                                value={x.userId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      )}
                    </div>
                  </div>

                  <div>&nbsp;</div>

                  <div style={{ width: "80%" }}>
                    &nbsp;
                    <Column {...YieldEstiamtionconfig} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card card-primary shadow">
                <div className="card-header">
                  <h3 className="card-title">Estimated Yield Vs. Actual Harvest</h3>

                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["salesreturnid"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          setRegionCropsYieldEstiamtionVSHarvest(
                            e.target.value
                          );
                          loadcropwisecropsYieldEstiamtionVSHarvest(
                            cropwiseYieldEstiamtionVSHarvestAll,
                            0
                          );
                        }}
                      >
                        <option>--All--</option>
                        <option value="Regionwise">Regionwise</option>
                        <option value="Executivewise">Executivewise</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      {regionCropsYieldEstiamtionVSHarvest == "Regionwise" ? (
                        <select
                          id="regionId"
                          className="form-control"
                          ref={(el) => (frmRef.current["regionId"] = el)}
                          value={regionId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Region--") {
                              id = e.target.value;
                            }
                            loadcropwisecropsYieldEstiamtionVSHarvest(
                              cropwiseYieldEstiamtionVSHarvestAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Region--</option>
                          {regionData &&
                            regionData.map((x) => (
                              <option
                                key={x.regionId}
                                user-id={x.regionId}
                                value={x.regionId}
                              >
                                {x.regionName}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            var id = 0;
                            if (e.target.value != "--Select Executive--") {
                              id = e.target.value;
                            }
                            loadcropwisecropsYieldEstiamtionVSHarvest(
                              cropwiseYieldEstiamtionVSHarvestAll,
                              id
                            );
                          }}
                        >
                          <option>--Select Executive--</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option
                                key={x.userId}
                                user-id={x.userId}
                                value={x.userId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      )}
                    </div>
                  </div>

                  <div style={{ width: "80%" }}>
                    &nbsp;
                    <Column {...configbar2} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-primary shadow">
                <div className="card-header">
                  <h3 className="card-title">Goods Issue</h3>

                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>

                <div className="card-body">

                <div className="row">
                   <div className="col-md-3">
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["salesreturnid"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              setRegionCropsYieldEstiamtionVSHarvest(e.target.value);
                              loadcropwisecropsYieldEstiamtionVSHarvest(
                                cropwiseYieldEstiamtionVSHarvestAll,
                                0
                              );
                            }}
                          >
                            <option>--All--</option>
                            <option value="Regionwise">Regionwise</option>
                            <option value="Executivewise">Executivewise</option>
                          </select>

                    </div>

                    <div className="col-md-3">
                    {regionCropsYieldEstiamtionVSHarvest == "Regionwise" ? (
                      <select
                        id="regionId"
                        className="form-control"
                        ref={(el) => (frmRef.current["regionId"] = el)}
                        value={regionId}
                        onChange={(e) => {
                          var id = 0;
                          if (e.target.value != "--Select Region--") {
                            id = e.target.value;
                          }
                          loadcropwisecropsYieldEstiamtionVSHarvest(
                            cropwiseYieldEstiamtionVSHarvestAll,
                            id
                          );
                        }}
                      >
                        <option>--Select Region--</option>
                        {regionData &&
                          regionData.map((x) => (
                            <option
                              key={x.regionId}
                              user-id={x.regionId}
                              value={x.regionId}
                            >
                              {x.regionName}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          var id = 0;
                          if (e.target.value != "--Select Executive--") {
                            id = e.target.value;
                          }
                          loadcropwisecropsYieldEstiamtionVSHarvest(
                            cropwiseYieldEstiamtionVSHarvestAll,
                            id
                          );
                        }}
                      >
                        <option>--Select Executive--</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.userId}
                              user-id={x.userId}
                              value={x.userId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    )}
                  </div>
                  </div>
                  <div>&nbsp;</div>

                  <div style={{ width: "80%" }}>
                    &nbsp;
                    <Column {...goodsIssueDetailConfig} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CommercialChart;
